/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as MfaChallengeRouteImport } from './routes/mfa-challenge'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ClientRouteImport } from './routes/_client'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TTokenRouteImport } from './routes/t.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as McpAuthorizeRouteImport } from './routes/mcp.authorize'
import { Route as ITokenRouteImport } from './routes/i.$token'
import { Route as CTokenRouteImport } from './routes/c.$token'
import { Route as BookSlugRouteImport } from './routes/book.$slug'
import { Route as ClientTasksRouteImport } from './routes/_client/tasks'
import { Route as ClientProfileRouteImport } from './routes/_client/profile'
import { Route as ClientOfferServicesRouteImport } from './routes/_client/offer-services'
import { Route as ClientMessagesRouteImport } from './routes/_client/messages'
import { Route as ClientHomeRouteImport } from './routes/_client/home'
import { Route as ClientBookingsRouteImport } from './routes/_client/bookings'
import { Route as AppWorkflowsRouteImport } from './routes/_app/workflows'
import { Route as AppVerificationRouteImport } from './routes/_app/verification'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppServiceDueRouteImport } from './routes/_app/service-due'
import { Route as AppScheduleRouteImport } from './routes/_app/schedule'
import { Route as AppRoutesRouteImport } from './routes/_app/routes'
import { Route as AppReviewsRouteImport } from './routes/_app/reviews'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppQuotesRouteImport } from './routes/_app/quotes'
import { Route as AppPurchasingRouteImport } from './routes/_app/purchasing'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppPayoutsRouteImport } from './routes/_app/payouts'
import { Route as AppMktBookingsRouteImport } from './routes/_app/mkt-bookings'
import { Route as AppMarketplaceRouteImport } from './routes/_app/marketplace'
import { Route as AppMarketingRouteImport } from './routes/_app/marketing'
import { Route as AppMaintenanceRouteImport } from './routes/_app/maintenance'
import { Route as AppListingRouteImport } from './routes/_app/listing'
import { Route as AppLeadsRouteImport } from './routes/_app/leads'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppInvoicesRouteImport } from './routes/_app/invoices'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppFormsRouteImport } from './routes/_app/forms'
import { Route as AppExpensesRouteImport } from './routes/_app/expenses'
import { Route as AppEquipmentRouteImport } from './routes/_app/equipment'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppComplianceRouteImport } from './routes/_app/compliance'
import { Route as AppClientsRouteImport } from './routes/_app/clients'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as ClientTasksNewRouteImport } from './routes/_client/tasks_.new'
import { Route as ClientTasksIdRouteImport } from './routes/_client/tasks_.$id'
import { Route as ClientMessagesIdRouteImport } from './routes/_client/messages_.$id'
import { Route as ClientBookingsIdRouteImport } from './routes/_client/bookings_.$id'
import { Route as AppWorkflowsIdRouteImport } from './routes/_app/workflows_.$id'
import { Route as AppReportsIdRouteImport } from './routes/_app/reports_.$id'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes_.$id'
import { Route as AppMarketplaceIdRouteImport } from './routes/_app/marketplace_.$id'
import { Route as AppMarketingIdRouteImport } from './routes/_app/marketing_.$id'
import { Route as AppJobsNewRouteImport } from './routes/_app/jobs_.new'
import { Route as AppJobsIdRouteImport } from './routes/_app/jobs_.$id'
import { Route as AppInvoicesIdRouteImport } from './routes/_app/invoices_.$id'
import { Route as AppInboxIdRouteImport } from './routes/_app/inbox_.$id'
import { Route as AppFormsIdRouteImport } from './routes/_app/forms_.$id'
import { Route as AppComplianceIdRouteImport } from './routes/_app/compliance_.$id'
import { Route as AppClientsIdRouteImport } from './routes/_app/clients_.$id'
import { Route as ClientPayTestPaymentRouteImport } from './routes/_client/pay.test.$payment'
import { Route as ClientHireSlugServiceRouteImport } from './routes/_client/hire.$slug.$service'
import { Route as AppJobsIdSwmsRouteImport } from './routes/_app/jobs_.$id_.swms'
import { Route as AppJobsIdEditRouteImport } from './routes/_app/jobs_.$id_.edit'
import { Route as AppFormsIdEditRouteImport } from './routes/_app/forms_.$id_.edit'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaChallengeRoute = MfaChallengeRouteImport.update({
  id: '/mfa-challenge',
  path: '/mfa-challenge',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRoute = ClientRouteImport.update({
  id: '/_client',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TTokenRoute = TTokenRouteImport.update({
  id: '/t/$token',
  path: '/t/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const McpAuthorizeRoute = McpAuthorizeRouteImport.update({
  id: '/mcp/authorize',
  path: '/mcp/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CTokenRoute = CTokenRouteImport.update({
  id: '/c/$token',
  path: '/c/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BookSlugRoute = BookSlugRouteImport.update({
  id: '/book/$slug',
  path: '/book/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientTasksRoute = ClientTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => ClientRoute,
} as any)
const ClientProfileRoute = ClientProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ClientRoute,
} as any)
const ClientOfferServicesRoute = ClientOfferServicesRouteImport.update({
  id: '/offer-services',
  path: '/offer-services',
  getParentRoute: () => ClientRoute,
} as any)
const ClientMessagesRoute = ClientMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => ClientRoute,
} as any)
const ClientHomeRoute = ClientHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookingsRoute = ClientBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => ClientRoute,
} as any)
const AppWorkflowsRoute = AppWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AppRoute,
} as any)
const AppVerificationRoute = AppVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceDueRoute = AppServiceDueRouteImport.update({
  id: '/service-due',
  path: '/service-due',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleRoute = AppScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppRoute,
} as any)
const AppRoutesRoute = AppRoutesRouteImport.update({
  id: '/routes',
  path: '/routes',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsRoute = AppReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesRoute = AppQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingRoute = AppPurchasingRouteImport.update({
  id: '/purchasing',
  path: '/purchasing',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppPayoutsRoute = AppPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AppRoute,
} as any)
const AppMktBookingsRoute = AppMktBookingsRouteImport.update({
  id: '/mkt-bookings',
  path: '/mkt-bookings',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceRoute = AppMarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingRoute = AppMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppMaintenanceRoute = AppMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AppRoute,
} as any)
const AppListingRoute = AppListingRouteImport.update({
  id: '/listing',
  path: '/listing',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsRoute = AppJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsRoute = AppFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRoute = AppExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppEquipmentRoute = AppEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppComplianceRoute = AppComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const ClientTasksNewRoute = ClientTasksNewRouteImport.update({
  id: '/tasks_/new',
  path: '/tasks/new',
  getParentRoute: () => ClientRoute,
} as any)
const ClientTasksIdRoute = ClientTasksIdRouteImport.update({
  id: '/tasks_/$id',
  path: '/tasks/$id',
  getParentRoute: () => ClientRoute,
} as any)
const ClientMessagesIdRoute = ClientMessagesIdRouteImport.update({
  id: '/messages_/$id',
  path: '/messages/$id',
  getParentRoute: () => ClientRoute,
} as any)
const ClientBookingsIdRoute = ClientBookingsIdRouteImport.update({
  id: '/bookings_/$id',
  path: '/bookings/$id',
  getParentRoute: () => ClientRoute,
} as any)
const AppWorkflowsIdRoute = AppWorkflowsIdRouteImport.update({
  id: '/workflows_/$id',
  path: '/workflows/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIdRoute = AppReportsIdRouteImport.update({
  id: '/reports_/$id',
  path: '/reports/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes_/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceIdRoute = AppMarketplaceIdRouteImport.update({
  id: '/marketplace_/$id',
  path: '/marketplace/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingIdRoute = AppMarketingIdRouteImport.update({
  id: '/marketing_/$id',
  path: '/marketing/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsNewRoute = AppJobsNewRouteImport.update({
  id: '/jobs_/new',
  path: '/jobs/new',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIdRoute = AppJobsIdRouteImport.update({
  id: '/jobs_/$id',
  path: '/jobs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/invoices_/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIdRoute = AppInboxIdRouteImport.update({
  id: '/inbox_/$id',
  path: '/inbox/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIdRoute = AppFormsIdRouteImport.update({
  id: '/forms_/$id',
  path: '/forms/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppComplianceIdRoute = AppComplianceIdRouteImport.update({
  id: '/compliance_/$id',
  path: '/compliance/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIdRoute = AppClientsIdRouteImport.update({
  id: '/clients_/$id',
  path: '/clients/$id',
  getParentRoute: () => AppRoute,
} as any)
const ClientPayTestPaymentRoute = ClientPayTestPaymentRouteImport.update({
  id: '/pay/test/$payment',
  path: '/pay/test/$payment',
  getParentRoute: () => ClientRoute,
} as any)
const ClientHireSlugServiceRoute = ClientHireSlugServiceRouteImport.update({
  id: '/hire/$slug/$service',
  path: '/hire/$slug/$service',
  getParentRoute: () => ClientRoute,
} as any)
const AppJobsIdSwmsRoute = AppJobsIdSwmsRouteImport.update({
  id: '/jobs_/$id_/swms',
  path: '/jobs/$id/swms',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsIdEditRoute = AppJobsIdEditRouteImport.update({
  id: '/jobs_/$id_/edit',
  path: '/jobs/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIdEditRoute = AppFormsIdEditRouteImport.update({
  id: '/forms_/$id_/edit',
  path: '/forms/$id/edit',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/mfa-challenge': typeof MfaChallengeRoute
  '/ops': typeof OpsRoute
  '/portal': typeof PortalRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/welcome': typeof WelcomeRoute
  '/account': typeof AppAccountRoute
  '/clients': typeof AppClientsRoute
  '/compliance': typeof AppComplianceRoute
  '/dashboard': typeof AppDashboardRoute
  '/documents': typeof AppDocumentsRoute
  '/equipment': typeof AppEquipmentRoute
  '/expenses': typeof AppExpensesRoute
  '/forms': typeof AppFormsRoute
  '/inbox': typeof AppInboxRoute
  '/inventory': typeof AppInventoryRoute
  '/invoices': typeof AppInvoicesRoute
  '/jobs': typeof AppJobsRoute
  '/leads': typeof AppLeadsRoute
  '/listing': typeof AppListingRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/marketing': typeof AppMarketingRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/mkt-bookings': typeof AppMktBookingsRoute
  '/payouts': typeof AppPayoutsRoute
  '/pricing': typeof AppPricingRoute
  '/purchasing': typeof AppPurchasingRoute
  '/quotes': typeof AppQuotesRoute
  '/reports': typeof AppReportsRoute
  '/reviews': typeof AppReviewsRoute
  '/routes': typeof AppRoutesRoute
  '/schedule': typeof AppScheduleRoute
  '/service-due': typeof AppServiceDueRoute
  '/settings': typeof AppSettingsRoute
  '/templates': typeof AppTemplatesRoute
  '/verification': typeof AppVerificationRoute
  '/workflows': typeof AppWorkflowsRoute
  '/bookings': typeof ClientBookingsRoute
  '/home': typeof ClientHomeRoute
  '/messages': typeof ClientMessagesRoute
  '/offer-services': typeof ClientOfferServicesRoute
  '/profile': typeof ClientProfileRoute
  '/tasks': typeof ClientTasksRoute
  '/book/$slug': typeof BookSlugRoute
  '/c/$token': typeof CTokenRoute
  '/i/$token': typeof ITokenRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/p/$slug': typeof PSlugRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/s/$token': typeof STokenRoute
  '/t/$token': typeof TTokenRoute
  '/clients/$id': typeof AppClientsIdRoute
  '/compliance/$id': typeof AppComplianceIdRoute
  '/forms/$id': typeof AppFormsIdRoute
  '/inbox/$id': typeof AppInboxIdRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/jobs/$id': typeof AppJobsIdRoute
  '/jobs/new': typeof AppJobsNewRoute
  '/marketing/$id': typeof AppMarketingIdRoute
  '/marketplace/$id': typeof AppMarketplaceIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/reports/$id': typeof AppReportsIdRoute
  '/workflows/$id': typeof AppWorkflowsIdRoute
  '/bookings/$id': typeof ClientBookingsIdRoute
  '/messages/$id': typeof ClientMessagesIdRoute
  '/tasks/$id': typeof ClientTasksIdRoute
  '/tasks/new': typeof ClientTasksNewRoute
  '/forms/$id/edit': typeof AppFormsIdEditRoute
  '/jobs/$id/edit': typeof AppJobsIdEditRoute
  '/jobs/$id/swms': typeof AppJobsIdSwmsRoute
  '/hire/$slug/$service': typeof ClientHireSlugServiceRoute
  '/pay/test/$payment': typeof ClientPayTestPaymentRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/mfa-challenge': typeof MfaChallengeRoute
  '/ops': typeof OpsRoute
  '/portal': typeof PortalRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/welcome': typeof WelcomeRoute
  '/account': typeof AppAccountRoute
  '/clients': typeof AppClientsRoute
  '/compliance': typeof AppComplianceRoute
  '/dashboard': typeof AppDashboardRoute
  '/documents': typeof AppDocumentsRoute
  '/equipment': typeof AppEquipmentRoute
  '/expenses': typeof AppExpensesRoute
  '/forms': typeof AppFormsRoute
  '/inbox': typeof AppInboxRoute
  '/inventory': typeof AppInventoryRoute
  '/invoices': typeof AppInvoicesRoute
  '/jobs': typeof AppJobsRoute
  '/leads': typeof AppLeadsRoute
  '/listing': typeof AppListingRoute
  '/maintenance': typeof AppMaintenanceRoute
  '/marketing': typeof AppMarketingRoute
  '/marketplace': typeof AppMarketplaceRoute
  '/mkt-bookings': typeof AppMktBookingsRoute
  '/payouts': typeof AppPayoutsRoute
  '/pricing': typeof AppPricingRoute
  '/purchasing': typeof AppPurchasingRoute
  '/quotes': typeof AppQuotesRoute
  '/reports': typeof AppReportsRoute
  '/reviews': typeof AppReviewsRoute
  '/routes': typeof AppRoutesRoute
  '/schedule': typeof AppScheduleRoute
  '/service-due': typeof AppServiceDueRoute
  '/settings': typeof AppSettingsRoute
  '/templates': typeof AppTemplatesRoute
  '/verification': typeof AppVerificationRoute
  '/workflows': typeof AppWorkflowsRoute
  '/bookings': typeof ClientBookingsRoute
  '/home': typeof ClientHomeRoute
  '/messages': typeof ClientMessagesRoute
  '/offer-services': typeof ClientOfferServicesRoute
  '/profile': typeof ClientProfileRoute
  '/tasks': typeof ClientTasksRoute
  '/book/$slug': typeof BookSlugRoute
  '/c/$token': typeof CTokenRoute
  '/i/$token': typeof ITokenRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/p/$slug': typeof PSlugRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/s/$token': typeof STokenRoute
  '/t/$token': typeof TTokenRoute
  '/clients/$id': typeof AppClientsIdRoute
  '/compliance/$id': typeof AppComplianceIdRoute
  '/forms/$id': typeof AppFormsIdRoute
  '/inbox/$id': typeof AppInboxIdRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/jobs/$id': typeof AppJobsIdRoute
  '/jobs/new': typeof AppJobsNewRoute
  '/marketing/$id': typeof AppMarketingIdRoute
  '/marketplace/$id': typeof AppMarketplaceIdRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/reports/$id': typeof AppReportsIdRoute
  '/workflows/$id': typeof AppWorkflowsIdRoute
  '/bookings/$id': typeof ClientBookingsIdRoute
  '/messages/$id': typeof ClientMessagesIdRoute
  '/tasks/$id': typeof ClientTasksIdRoute
  '/tasks/new': typeof ClientTasksNewRoute
  '/forms/$id/edit': typeof AppFormsIdEditRoute
  '/jobs/$id/edit': typeof AppJobsIdEditRoute
  '/jobs/$id/swms': typeof AppJobsIdSwmsRoute
  '/hire/$slug/$service': typeof ClientHireSlugServiceRoute
  '/pay/test/$payment': typeof ClientPayTestPaymentRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_client': typeof ClientRouteWithChildren
  '/admin': typeof AdminRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/mfa-challenge': typeof MfaChallengeRoute
  '/ops': typeof OpsRoute
  '/portal': typeof PortalRoute
  '/reset-password': typeof ResetPasswordRoute
  '/search': typeof SearchRoute
  '/signup': typeof SignupRoute
  '/welcome': typeof WelcomeRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/clients': typeof AppClientsRoute
  '/_app/compliance': typeof AppComplianceRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/documents': typeof AppDocumentsRoute
  '/_app/equipment': typeof AppEquipmentRoute
  '/_app/expenses': typeof AppExpensesRoute
  '/_app/forms': typeof AppFormsRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/invoices': typeof AppInvoicesRoute
  '/_app/jobs': typeof AppJobsRoute
  '/_app/leads': typeof AppLeadsRoute
  '/_app/listing': typeof AppListingRoute
  '/_app/maintenance': typeof AppMaintenanceRoute
  '/_app/marketing': typeof AppMarketingRoute
  '/_app/marketplace': typeof AppMarketplaceRoute
  '/_app/mkt-bookings': typeof AppMktBookingsRoute
  '/_app/payouts': typeof AppPayoutsRoute
  '/_app/pricing': typeof AppPricingRoute
  '/_app/purchasing': typeof AppPurchasingRoute
  '/_app/quotes': typeof AppQuotesRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/reviews': typeof AppReviewsRoute
  '/_app/routes': typeof AppRoutesRoute
  '/_app/schedule': typeof AppScheduleRoute
  '/_app/service-due': typeof AppServiceDueRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/templates': typeof AppTemplatesRoute
  '/_app/verification': typeof AppVerificationRoute
  '/_app/workflows': typeof AppWorkflowsRoute
  '/_client/bookings': typeof ClientBookingsRoute
  '/_client/home': typeof ClientHomeRoute
  '/_client/messages': typeof ClientMessagesRoute
  '/_client/offer-services': typeof ClientOfferServicesRoute
  '/_client/profile': typeof ClientProfileRoute
  '/_client/tasks': typeof ClientTasksRoute
  '/book/$slug': typeof BookSlugRoute
  '/c/$token': typeof CTokenRoute
  '/i/$token': typeof ITokenRoute
  '/mcp/authorize': typeof McpAuthorizeRoute
  '/p/$slug': typeof PSlugRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/s/$token': typeof STokenRoute
  '/t/$token': typeof TTokenRoute
  '/_app/clients_/$id': typeof AppClientsIdRoute
  '/_app/compliance_/$id': typeof AppComplianceIdRoute
  '/_app/forms_/$id': typeof AppFormsIdRoute
  '/_app/inbox_/$id': typeof AppInboxIdRoute
  '/_app/invoices_/$id': typeof AppInvoicesIdRoute
  '/_app/jobs_/$id': typeof AppJobsIdRoute
  '/_app/jobs_/new': typeof AppJobsNewRoute
  '/_app/marketing_/$id': typeof AppMarketingIdRoute
  '/_app/marketplace_/$id': typeof AppMarketplaceIdRoute
  '/_app/quotes_/$id': typeof AppQuotesIdRoute
  '/_app/reports_/$id': typeof AppReportsIdRoute
  '/_app/workflows_/$id': typeof AppWorkflowsIdRoute
  '/_client/bookings_/$id': typeof ClientBookingsIdRoute
  '/_client/messages_/$id': typeof ClientMessagesIdRoute
  '/_client/tasks_/$id': typeof ClientTasksIdRoute
  '/_client/tasks_/new': typeof ClientTasksNewRoute
  '/_app/forms_/$id_/edit': typeof AppFormsIdEditRoute
  '/_app/jobs_/$id_/edit': typeof AppJobsIdEditRoute
  '/_app/jobs_/$id_/swms': typeof AppJobsIdSwmsRoute
  '/_client/hire/$slug/$service': typeof ClientHireSlugServiceRoute
  '/_client/pay/test/$payment': typeof ClientPayTestPaymentRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/join'
    | '/login'
    | '/mfa-challenge'
    | '/ops'
    | '/portal'
    | '/reset-password'
    | '/search'
    | '/signup'
    | '/welcome'
    | '/account'
    | '/clients'
    | '/compliance'
    | '/dashboard'
    | '/documents'
    | '/equipment'
    | '/expenses'
    | '/forms'
    | '/inbox'
    | '/inventory'
    | '/invoices'
    | '/jobs'
    | '/leads'
    | '/listing'
    | '/maintenance'
    | '/marketing'
    | '/marketplace'
    | '/mkt-bookings'
    | '/payouts'
    | '/pricing'
    | '/purchasing'
    | '/quotes'
    | '/reports'
    | '/reviews'
    | '/routes'
    | '/schedule'
    | '/service-due'
    | '/settings'
    | '/templates'
    | '/verification'
    | '/workflows'
    | '/bookings'
    | '/home'
    | '/messages'
    | '/offer-services'
    | '/profile'
    | '/tasks'
    | '/book/$slug'
    | '/c/$token'
    | '/i/$token'
    | '/mcp/authorize'
    | '/p/$slug'
    | '/q/$token'
    | '/r/$token'
    | '/s/$token'
    | '/t/$token'
    | '/clients/$id'
    | '/compliance/$id'
    | '/forms/$id'
    | '/inbox/$id'
    | '/invoices/$id'
    | '/jobs/$id'
    | '/jobs/new'
    | '/marketing/$id'
    | '/marketplace/$id'
    | '/quotes/$id'
    | '/reports/$id'
    | '/workflows/$id'
    | '/bookings/$id'
    | '/messages/$id'
    | '/tasks/$id'
    | '/tasks/new'
    | '/forms/$id/edit'
    | '/jobs/$id/edit'
    | '/jobs/$id/swms'
    | '/hire/$slug/$service'
    | '/pay/test/$payment'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/join'
    | '/login'
    | '/mfa-challenge'
    | '/ops'
    | '/portal'
    | '/reset-password'
    | '/search'
    | '/signup'
    | '/welcome'
    | '/account'
    | '/clients'
    | '/compliance'
    | '/dashboard'
    | '/documents'
    | '/equipment'
    | '/expenses'
    | '/forms'
    | '/inbox'
    | '/inventory'
    | '/invoices'
    | '/jobs'
    | '/leads'
    | '/listing'
    | '/maintenance'
    | '/marketing'
    | '/marketplace'
    | '/mkt-bookings'
    | '/payouts'
    | '/pricing'
    | '/purchasing'
    | '/quotes'
    | '/reports'
    | '/reviews'
    | '/routes'
    | '/schedule'
    | '/service-due'
    | '/settings'
    | '/templates'
    | '/verification'
    | '/workflows'
    | '/bookings'
    | '/home'
    | '/messages'
    | '/offer-services'
    | '/profile'
    | '/tasks'
    | '/book/$slug'
    | '/c/$token'
    | '/i/$token'
    | '/mcp/authorize'
    | '/p/$slug'
    | '/q/$token'
    | '/r/$token'
    | '/s/$token'
    | '/t/$token'
    | '/clients/$id'
    | '/compliance/$id'
    | '/forms/$id'
    | '/inbox/$id'
    | '/invoices/$id'
    | '/jobs/$id'
    | '/jobs/new'
    | '/marketing/$id'
    | '/marketplace/$id'
    | '/quotes/$id'
    | '/reports/$id'
    | '/workflows/$id'
    | '/bookings/$id'
    | '/messages/$id'
    | '/tasks/$id'
    | '/tasks/new'
    | '/forms/$id/edit'
    | '/jobs/$id/edit'
    | '/jobs/$id/swms'
    | '/hire/$slug/$service'
    | '/pay/test/$payment'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_client'
    | '/admin'
    | '/join'
    | '/login'
    | '/mfa-challenge'
    | '/ops'
    | '/portal'
    | '/reset-password'
    | '/search'
    | '/signup'
    | '/welcome'
    | '/_app/account'
    | '/_app/clients'
    | '/_app/compliance'
    | '/_app/dashboard'
    | '/_app/documents'
    | '/_app/equipment'
    | '/_app/expenses'
    | '/_app/forms'
    | '/_app/inbox'
    | '/_app/inventory'
    | '/_app/invoices'
    | '/_app/jobs'
    | '/_app/leads'
    | '/_app/listing'
    | '/_app/maintenance'
    | '/_app/marketing'
    | '/_app/marketplace'
    | '/_app/mkt-bookings'
    | '/_app/payouts'
    | '/_app/pricing'
    | '/_app/purchasing'
    | '/_app/quotes'
    | '/_app/reports'
    | '/_app/reviews'
    | '/_app/routes'
    | '/_app/schedule'
    | '/_app/service-due'
    | '/_app/settings'
    | '/_app/templates'
    | '/_app/verification'
    | '/_app/workflows'
    | '/_client/bookings'
    | '/_client/home'
    | '/_client/messages'
    | '/_client/offer-services'
    | '/_client/profile'
    | '/_client/tasks'
    | '/book/$slug'
    | '/c/$token'
    | '/i/$token'
    | '/mcp/authorize'
    | '/p/$slug'
    | '/q/$token'
    | '/r/$token'
    | '/s/$token'
    | '/t/$token'
    | '/_app/clients_/$id'
    | '/_app/compliance_/$id'
    | '/_app/forms_/$id'
    | '/_app/inbox_/$id'
    | '/_app/invoices_/$id'
    | '/_app/jobs_/$id'
    | '/_app/jobs_/new'
    | '/_app/marketing_/$id'
    | '/_app/marketplace_/$id'
    | '/_app/quotes_/$id'
    | '/_app/reports_/$id'
    | '/_app/workflows_/$id'
    | '/_client/bookings_/$id'
    | '/_client/messages_/$id'
    | '/_client/tasks_/$id'
    | '/_client/tasks_/new'
    | '/_app/forms_/$id_/edit'
    | '/_app/jobs_/$id_/edit'
    | '/_app/jobs_/$id_/swms'
    | '/_client/hire/$slug/$service'
    | '/_client/pay/test/$payment'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ClientRoute: typeof ClientRouteWithChildren
  AdminRoute: typeof AdminRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  MfaChallengeRoute: typeof MfaChallengeRoute
  OpsRoute: typeof OpsRoute
  PortalRoute: typeof PortalRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SearchRoute: typeof SearchRoute
  SignupRoute: typeof SignupRoute
  WelcomeRoute: typeof WelcomeRoute
  BookSlugRoute: typeof BookSlugRoute
  CTokenRoute: typeof CTokenRoute
  ITokenRoute: typeof ITokenRoute
  McpAuthorizeRoute: typeof McpAuthorizeRoute
  PSlugRoute: typeof PSlugRoute
  QTokenRoute: typeof QTokenRoute
  RTokenRoute: typeof RTokenRoute
  STokenRoute: typeof STokenRoute
  TTokenRoute: typeof TTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-challenge': {
      id: '/mfa-challenge'
      path: '/mfa-challenge'
      fullPath: '/mfa-challenge'
      preLoaderRoute: typeof MfaChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client': {
      id: '/_client'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$token': {
      id: '/t/$token'
      path: '/t/$token'
      fullPath: '/t/$token'
      preLoaderRoute: typeof TTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp/authorize': {
      id: '/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof McpAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$token': {
      id: '/c/$token'
      path: '/c/$token'
      fullPath: '/c/$token'
      preLoaderRoute: typeof CTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$slug': {
      id: '/book/$slug'
      path: '/book/$slug'
      fullPath: '/book/$slug'
      preLoaderRoute: typeof BookSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_client/tasks': {
      id: '/_client/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof ClientTasksRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/profile': {
      id: '/_client/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ClientProfileRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/offer-services': {
      id: '/_client/offer-services'
      path: '/offer-services'
      fullPath: '/offer-services'
      preLoaderRoute: typeof ClientOfferServicesRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/messages': {
      id: '/_client/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof ClientMessagesRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/home': {
      id: '/_client/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ClientHomeRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/bookings': {
      id: '/_client/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof ClientBookingsRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_app/workflows': {
      id: '/_app/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AppWorkflowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verification': {
      id: '/_app/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof AppVerificationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-due': {
      id: '/_app/service-due'
      path: '/service-due'
      fullPath: '/service-due'
      preLoaderRoute: typeof AppServiceDueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule': {
      id: '/_app/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AppScheduleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/routes': {
      id: '/_app/routes'
      path: '/routes'
      fullPath: '/routes'
      preLoaderRoute: typeof AppRoutesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviews': {
      id: '/_app/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof AppReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes': {
      id: '/_app/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof AppQuotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing': {
      id: '/_app/purchasing'
      path: '/purchasing'
      fullPath: '/purchasing'
      preLoaderRoute: typeof AppPurchasingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payouts': {
      id: '/_app/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AppPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mkt-bookings': {
      id: '/_app/mkt-bookings'
      path: '/mkt-bookings'
      fullPath: '/mkt-bookings'
      preLoaderRoute: typeof AppMktBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace': {
      id: '/_app/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof AppMarketplaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing': {
      id: '/_app/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AppMarketingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maintenance': {
      id: '/_app/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof AppMaintenanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/listing': {
      id: '/_app/listing'
      path: '/listing'
      fullPath: '/listing'
      preLoaderRoute: typeof AppListingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads': {
      id: '/_app/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs': {
      id: '/_app/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AppJobsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms': {
      id: '/_app/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AppFormsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses': {
      id: '/_app/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AppExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/equipment': {
      id: '/_app/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof AppEquipmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compliance': {
      id: '/_app/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AppComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_client/tasks_/new': {
      id: '/_client/tasks_/new'
      path: '/tasks/new'
      fullPath: '/tasks/new'
      preLoaderRoute: typeof ClientTasksNewRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/tasks_/$id': {
      id: '/_client/tasks_/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof ClientTasksIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/messages_/$id': {
      id: '/_client/messages_/$id'
      path: '/messages/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof ClientMessagesIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/bookings_/$id': {
      id: '/_client/bookings_/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof ClientBookingsIdRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_app/workflows_/$id': {
      id: '/_app/workflows_/$id'
      path: '/workflows/$id'
      fullPath: '/workflows/$id'
      preLoaderRoute: typeof AppWorkflowsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports_/$id': {
      id: '/_app/reports_/$id'
      path: '/reports/$id'
      fullPath: '/reports/$id'
      preLoaderRoute: typeof AppReportsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes_/$id': {
      id: '/_app/quotes_/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace_/$id': {
      id: '/_app/marketplace_/$id'
      path: '/marketplace/$id'
      fullPath: '/marketplace/$id'
      preLoaderRoute: typeof AppMarketplaceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing_/$id': {
      id: '/_app/marketing_/$id'
      path: '/marketing/$id'
      fullPath: '/marketing/$id'
      preLoaderRoute: typeof AppMarketingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs_/new': {
      id: '/_app/jobs_/new'
      path: '/jobs/new'
      fullPath: '/jobs/new'
      preLoaderRoute: typeof AppJobsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs_/$id': {
      id: '/_app/jobs_/$id'
      path: '/jobs/$id'
      fullPath: '/jobs/$id'
      preLoaderRoute: typeof AppJobsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices_/$id': {
      id: '/_app/invoices_/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox_/$id': {
      id: '/_app/inbox_/$id'
      path: '/inbox/$id'
      fullPath: '/inbox/$id'
      preLoaderRoute: typeof AppInboxIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms_/$id': {
      id: '/_app/forms_/$id'
      path: '/forms/$id'
      fullPath: '/forms/$id'
      preLoaderRoute: typeof AppFormsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compliance_/$id': {
      id: '/_app/compliance_/$id'
      path: '/compliance/$id'
      fullPath: '/compliance/$id'
      preLoaderRoute: typeof AppComplianceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients_/$id': {
      id: '/_app/clients_/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AppClientsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_client/pay/test/$payment': {
      id: '/_client/pay/test/$payment'
      path: '/pay/test/$payment'
      fullPath: '/pay/test/$payment'
      preLoaderRoute: typeof ClientPayTestPaymentRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_client/hire/$slug/$service': {
      id: '/_client/hire/$slug/$service'
      path: '/hire/$slug/$service'
      fullPath: '/hire/$slug/$service'
      preLoaderRoute: typeof ClientHireSlugServiceRouteImport
      parentRoute: typeof ClientRoute
    }
    '/_app/jobs_/$id_/swms': {
      id: '/_app/jobs_/$id_/swms'
      path: '/jobs/$id/swms'
      fullPath: '/jobs/$id/swms'
      preLoaderRoute: typeof AppJobsIdSwmsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs_/$id_/edit': {
      id: '/_app/jobs_/$id_/edit'
      path: '/jobs/$id/edit'
      fullPath: '/jobs/$id/edit'
      preLoaderRoute: typeof AppJobsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms_/$id_/edit': {
      id: '/_app/forms_/$id_/edit'
      path: '/forms/$id/edit'
      fullPath: '/forms/$id/edit'
      preLoaderRoute: typeof AppFormsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppClientsRoute: typeof AppClientsRoute
  AppComplianceRoute: typeof AppComplianceRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppEquipmentRoute: typeof AppEquipmentRoute
  AppExpensesRoute: typeof AppExpensesRoute
  AppFormsRoute: typeof AppFormsRoute
  AppInboxRoute: typeof AppInboxRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppInvoicesRoute: typeof AppInvoicesRoute
  AppJobsRoute: typeof AppJobsRoute
  AppLeadsRoute: typeof AppLeadsRoute
  AppListingRoute: typeof AppListingRoute
  AppMaintenanceRoute: typeof AppMaintenanceRoute
  AppMarketingRoute: typeof AppMarketingRoute
  AppMarketplaceRoute: typeof AppMarketplaceRoute
  AppMktBookingsRoute: typeof AppMktBookingsRoute
  AppPayoutsRoute: typeof AppPayoutsRoute
  AppPricingRoute: typeof AppPricingRoute
  AppPurchasingRoute: typeof AppPurchasingRoute
  AppQuotesRoute: typeof AppQuotesRoute
  AppReportsRoute: typeof AppReportsRoute
  AppReviewsRoute: typeof AppReviewsRoute
  AppRoutesRoute: typeof AppRoutesRoute
  AppScheduleRoute: typeof AppScheduleRoute
  AppServiceDueRoute: typeof AppServiceDueRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppVerificationRoute: typeof AppVerificationRoute
  AppWorkflowsRoute: typeof AppWorkflowsRoute
  AppClientsIdRoute: typeof AppClientsIdRoute
  AppComplianceIdRoute: typeof AppComplianceIdRoute
  AppFormsIdRoute: typeof AppFormsIdRoute
  AppInboxIdRoute: typeof AppInboxIdRoute
  AppInvoicesIdRoute: typeof AppInvoicesIdRoute
  AppJobsIdRoute: typeof AppJobsIdRoute
  AppJobsNewRoute: typeof AppJobsNewRoute
  AppMarketingIdRoute: typeof AppMarketingIdRoute
  AppMarketplaceIdRoute: typeof AppMarketplaceIdRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppReportsIdRoute: typeof AppReportsIdRoute
  AppWorkflowsIdRoute: typeof AppWorkflowsIdRoute
  AppFormsIdEditRoute: typeof AppFormsIdEditRoute
  AppJobsIdEditRoute: typeof AppJobsIdEditRoute
  AppJobsIdSwmsRoute: typeof AppJobsIdSwmsRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppClientsRoute: AppClientsRoute,
  AppComplianceRoute: AppComplianceRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppEquipmentRoute: AppEquipmentRoute,
  AppExpensesRoute: AppExpensesRoute,
  AppFormsRoute: AppFormsRoute,
  AppInboxRoute: AppInboxRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppInvoicesRoute: AppInvoicesRoute,
  AppJobsRoute: AppJobsRoute,
  AppLeadsRoute: AppLeadsRoute,
  AppListingRoute: AppListingRoute,
  AppMaintenanceRoute: AppMaintenanceRoute,
  AppMarketingRoute: AppMarketingRoute,
  AppMarketplaceRoute: AppMarketplaceRoute,
  AppMktBookingsRoute: AppMktBookingsRoute,
  AppPayoutsRoute: AppPayoutsRoute,
  AppPricingRoute: AppPricingRoute,
  AppPurchasingRoute: AppPurchasingRoute,
  AppQuotesRoute: AppQuotesRoute,
  AppReportsRoute: AppReportsRoute,
  AppReviewsRoute: AppReviewsRoute,
  AppRoutesRoute: AppRoutesRoute,
  AppScheduleRoute: AppScheduleRoute,
  AppServiceDueRoute: AppServiceDueRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppVerificationRoute: AppVerificationRoute,
  AppWorkflowsRoute: AppWorkflowsRoute,
  AppClientsIdRoute: AppClientsIdRoute,
  AppComplianceIdRoute: AppComplianceIdRoute,
  AppFormsIdRoute: AppFormsIdRoute,
  AppInboxIdRoute: AppInboxIdRoute,
  AppInvoicesIdRoute: AppInvoicesIdRoute,
  AppJobsIdRoute: AppJobsIdRoute,
  AppJobsNewRoute: AppJobsNewRoute,
  AppMarketingIdRoute: AppMarketingIdRoute,
  AppMarketplaceIdRoute: AppMarketplaceIdRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppReportsIdRoute: AppReportsIdRoute,
  AppWorkflowsIdRoute: AppWorkflowsIdRoute,
  AppFormsIdEditRoute: AppFormsIdEditRoute,
  AppJobsIdEditRoute: AppJobsIdEditRoute,
  AppJobsIdSwmsRoute: AppJobsIdSwmsRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface ClientRouteChildren {
  ClientBookingsRoute: typeof ClientBookingsRoute
  ClientHomeRoute: typeof ClientHomeRoute
  ClientMessagesRoute: typeof ClientMessagesRoute
  ClientOfferServicesRoute: typeof ClientOfferServicesRoute
  ClientProfileRoute: typeof ClientProfileRoute
  ClientTasksRoute: typeof ClientTasksRoute
  ClientBookingsIdRoute: typeof ClientBookingsIdRoute
  ClientMessagesIdRoute: typeof ClientMessagesIdRoute
  ClientTasksIdRoute: typeof ClientTasksIdRoute
  ClientTasksNewRoute: typeof ClientTasksNewRoute
  ClientHireSlugServiceRoute: typeof ClientHireSlugServiceRoute
  ClientPayTestPaymentRoute: typeof ClientPayTestPaymentRoute
}

const ClientRouteChildren: ClientRouteChildren = {
  ClientBookingsRoute: ClientBookingsRoute,
  ClientHomeRoute: ClientHomeRoute,
  ClientMessagesRoute: ClientMessagesRoute,
  ClientOfferServicesRoute: ClientOfferServicesRoute,
  ClientProfileRoute: ClientProfileRoute,
  ClientTasksRoute: ClientTasksRoute,
  ClientBookingsIdRoute: ClientBookingsIdRoute,
  ClientMessagesIdRoute: ClientMessagesIdRoute,
  ClientTasksIdRoute: ClientTasksIdRoute,
  ClientTasksNewRoute: ClientTasksNewRoute,
  ClientHireSlugServiceRoute: ClientHireSlugServiceRoute,
  ClientPayTestPaymentRoute: ClientPayTestPaymentRoute,
}

const ClientRouteWithChildren =
  ClientRoute._addFileChildren(ClientRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ClientRoute: ClientRouteWithChildren,
  AdminRoute: AdminRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  MfaChallengeRoute: MfaChallengeRoute,
  OpsRoute: OpsRoute,
  PortalRoute: PortalRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SearchRoute: SearchRoute,
  SignupRoute: SignupRoute,
  WelcomeRoute: WelcomeRoute,
  BookSlugRoute: BookSlugRoute,
  CTokenRoute: CTokenRoute,
  ITokenRoute: ITokenRoute,
  McpAuthorizeRoute: McpAuthorizeRoute,
  PSlugRoute: PSlugRoute,
  QTokenRoute: QTokenRoute,
  RTokenRoute: RTokenRoute,
  STokenRoute: STokenRoute,
  TTokenRoute: TTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
